export default {"src":"/blog/_next/static/media/chev_left.5c7d6a25.svg","height":10,"width":18};